import { DashboardActions, DashboardActionTypes } from '@app/core/store/actions/dashboard.action';

export const initialState: DashboardState = {
  searchText: '',
};

export interface DashboardState {
  searchText: string;
}

export function dashboardReducer(state: DashboardState = initialState, action: DashboardActions): DashboardState {
  switch (action.type) {
    case DashboardActionTypes.AddToSearchText:
      return {
        ...state,
        searchText: state.searchText + action.search,
      };
    case DashboardActionTypes.SetSearchText:
      return {
        ...state,
        searchText: action.search,
      };
    case DashboardActionTypes.ClearSearchText:
      return {
        ...state,
        searchText: '',
      };
    default:
      return {
        ...state,
      };
  }
}
